import React,{useRef, useState, useEffect, useContext} from "react";
import { Form, Col, Row, Button, Card} from "react-bootstrap";
import Select from "react-select";
import EditableRange from "../components/EditableRange";
import vindrApi from "../utils/vindrapi";
import { X, Trash, Angle, Subtract} from "@phosphor-icons/react";
import ColorPicker			from "../components/ColorPicker";
import LayerExclusion		from "../classes/LayerExclusion";
import LayerUpload			from "../components/LayerUpload";
import globalContext		from "../utils/globalContext";

export default function ExclusionUploadPanel({
	setup,
	handler,
	onClose,
	onChange,
	onSaveClose,
	onUpload,
	user,
	onColorChange
}) {
	
	const context				= useContext(globalContext);
	
	const handleClose = () => {
		
		if(onClose)
			onClose();
	}
	const handleSaveClose = () => {
		
		if(onSaveClose)
			onSaveClose();
	}
	const handleColorChange = (color)=>{
		
		if(onColorChange)
			onColorChange(color);
		
	}
	const handleUploadComplete = (layer) => {
		if(onUpload)
			onUpload(layer);
	}
	return (
		<div className="powerroads-panel power-roads" >
			<Row>
				<Col xs="12 title pb-2">
					<b>Upload exclusion zone</b>
					<span onClick={handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
				</Col>
				{!!setup.obj.exclusionId &&
				<Col xs="12 my-4">

					<label>Color</label>
					<ColorPicker onChange={handleColorChange} color={setup.obj.color ?? this.defaultColor} />
				</Col>
				}
				{!setup.obj.exclusionId && 
					<>
						<Col xs="12 my-3">

							Drag and drop files here or click to browse
						</Col>

						<Col xs="12 mb-3">
							<LayerUpload type={'exclusionLayer'} onUpload={handleUploadComplete} user={user} scenarioid={handler.tc.scenario.scenario_id} projectid={handler.tc.scenario.projectid} />
						</Col>
					</>
				}

				<Col xs="8">
					<Button variant="primary" onClick={handleSaveClose}>Save & close</Button>
				</Col>
				<Col xs="4 text-end">
				</Col>
			</Row>
		</div>	  
	);
	

}
